import { useState, memo, useMemo, useEffect } from "react";
import {
  AdvancedMarker,
  useAdvancedMarkerRef,
} from "@vis.gl/react-google-maps";
import type { Marker } from "@googlemaps/markerclusterer";
import { AdvancedIcon } from "./advancedIcon";
const Mark = ({
  orgId = undefined,
  poi,
  setMarkerRef,
  onDeleteCamera = (e: any) => void 0,
  selectedCamera = null,
  readOnly = false,
  highLighted = false,
}) => {
  const [markerRef] = useAdvancedMarkerRef();
  const [selected, setSelected] = useState(readOnly ? false : true);
  useEffect(() => {
    if (readOnly) return;
    setSelected(poi.defaultSelected);
  }, [poi]);
  const onConfirm = (e) => {
    if (readOnly) return;
    e.stopPropagation();
    setSelected(false);
  };
  const onClick = (e) => {
    if (selectedCamera || readOnly) {
      return;
    }
    e.stop();
    setSelected(true);
  };

  return (
    <>
      <AdvancedMarker
        clickable={true}
        style={{ cursor: "unset" }}
        className={selected ? "selected" : ""}
        zIndex={selected ? 1 : null}
        key={poi.key + "_camera"}
        position={poi.location}
        title={"camera_" + poi.key}
        ref={(marker) => {
          markerRef(marker);
          setMarkerRef(marker, poi.key);
        }}
        onClick={selectedCamera ? undefined : onClick}
      >
        <AdvancedIcon
          highLighted={highLighted}
          poi={poi}
          orgId={orgId}
          selected={selected}
          onConfirm={onConfirm}
          onDelete={onDeleteCamera}
        />
      </AdvancedMarker>
    </>
  );
};

export default memo(Mark);
